import { render, staticRenderFns } from "./tableB.vue?vue&type=template&id=5a5d05a4&"
import script from "./tableB.vue?vue&type=script&lang=js&"
export * from "./tableB.vue?vue&type=script&lang=js&"
import style0 from "./tableB.vue?vue&type=style&index=0&id=5a5d05a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports